import React from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';

import { BevelCutTypePreference } from '@paragon/contract-library';

const options: BevelCutTypePreference[] = ['PreferAny', 'PreferDouble', 'PreferNone'];

export const BevelCutTypePreferenceSelect = (props: {
  value: BevelCutTypePreference;
  onChange: (value: BevelCutTypePreference) => void;
}) => (
  <>
    <Typography gutterBottom variant="subtitle2">
      Preferred Bevel Cut
    </Typography>

    <ToggleButtonGroup exclusive fullWidth size="small" value={optionName(props.value)}>
      {options.map((option) => {
        const name = optionName(option);
        return (
          <Tooltip
            key={name}
            title={optionTooltipText(option)}
            disableInteractive
            onClick={() => props.onChange(option)}
          >
            <ToggleButton value={name} selected={props.value === option}>
              {name}
            </ToggleButton>
          </Tooltip>
        );
      })}
    </ToggleButtonGroup>
  </>
);

const optionName = (option: BevelCutTypePreference) =>
  option === 'PreferDouble' ? 'Double' : option === 'PreferNone' ? 'None' : 'Any';

const optionTooltipText = (option: BevelCutTypePreference) =>
  option === 'PreferDouble'
    ? 'Single bevel cuts will not be automatically generated.'
    : option === 'PreferNone'
      ? 'Bevel cuts will not be automatically generated.'
      : 'Generates the bevel cut which results in the longest truss.';
